import './TermOfUse.scss';
export default function TermOfUse({  }) {

    return (
        <div className="TermOfUse">

    <h1>Terms of Use</h1>
    <p><strong>Effective Date:</strong> August 6, 2025</p>

    <section>
      <h2>1. Acceptance of Terms</h2>
      <p>By accessing or using Emetya.com (“we,” “our,” “us,” or “Emetya”), you agree to comply with and be bound by these Terms of Use and all applicable laws and regulations. If you do not agree to these terms, please do not use our website.</p>
    </section>

    <section>
      <h2>2. Website Purpose</h2>
      <p>Emetya is an informational and affiliate marketing platform that showcases reviews, rankings, and comparisons of health-related products and services, including GLP-1 weight loss programs. We do not provide medical advice, treatment, or diagnosis.</p>
    </section>

    <section>
      <h2>3. Not Medical Advice</h2>
      <p>All content on Emetya.com is for educational and informational purposes only. It is not intended as a substitute for professional medical advice, diagnosis, or treatment. Always consult a licensed healthcare provider before starting any medical treatment, medication, or wellness program.</p>
    </section>

    <section>
      <h2>4. Affiliate Disclosure</h2>
      <p>Emetya may receive compensation when users click affiliate links or sign up for third-party services featured on this site. This compensation may influence the placement, order, and rating of products and services. However, all opinions expressed are our own and based on independent research.</p>
    </section>

    <section>
      <h2>5. User Responsibilities</h2>
      <ul>
        <li>You agree to use the website in accordance with all applicable laws and regulations.</li>
        <li>You will not use the site for any unlawful purpose, including but not limited to distributing malicious software or unauthorized advertising.</li>
        <li>You will not impersonate any other person or entity or misrepresent your affiliation with a third party.</li>
      </ul>
    </section>

    <section>
      <h2>6. Third-Party Links and Services</h2>
      <p>This site may contain links to third-party websites, services, or offers. These links are provided for convenience only. Emetya does not control and is not responsible for the content, privacy policies, or practices of any third-party site. Your interactions with such sites are solely between you and the third party.</p>
    </section>

    <section>
      <h2>7. Intellectual Property</h2>
      <p>All content, design elements, trademarks, logos, and other materials on Emetya.com are the property of Emetya or its licensors and are protected under applicable copyright and trademark laws. You may not copy, modify, distribute, or reproduce any material without prior written consent.</p>
    </section>

    <section>
      <h2>8. Disclaimer of Warranties</h2>
      <p>Emetya.com is provided “as is” and “as available,” without warranties of any kind. We do not guarantee that the site will be error-free, uninterrupted, or free of viruses. We disclaim all warranties, express or implied, including merchantability, fitness for a particular purpose, and non-infringement.</p>
    </section>

    <section>
      <h2>9. Limitation of Liability</h2>
      <p>To the fullest extent permitted by law, Emetya shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the site or any third-party service linked from it. This includes, but is not limited to, damages for loss of data, income, or profits.</p>
    </section>

    <section>
      <h2>10. Indemnification</h2>
      <p>You agree to indemnify and hold harmless Emetya, its affiliates, and partners from any claims, liabilities, damages, losses, or expenses arising out of your use of the site, your violation of these Terms, or your violation of any third-party rights.</p>
    </section>

    <section>
      <h2>11. Changes to the Terms</h2>
      <p>We reserve the right to modify these Terms of Use at any time. Updates will be posted on this page with a revised effective date. Your continued use of the site constitutes acceptance of any changes.</p>
    </section>

    <section>
      <h2>12. Governing Law</h2>
      <p>These Terms are governed by and construed in accordance with the laws of the State of California, without regard to conflict of law principles. Any legal action or proceeding arising under these Terms shall be brought exclusively in the courts located in Los Angeles County, California.</p>
    </section>

    <section>
      <h2>13. Contact Information</h2>
      <p>If you have any questions or concerns about these Terms of Use, please contact us:</p>
      <p>
        <strong>Email:</strong> <a href="mailto:legal@emetya.com">legal@emetya.com</a><br />
        <strong>Mailing Address:</strong> Emetya, 18015 Collins St, Encino, CA 91316
      </p>
    </section>
        </div >
    )
}

